import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
// console.log("zdrw");

const canvas = document.querySelector(".sticky canvas");
const context = canvas.getContext("2d");

const img = new Image();

const currentFrame = (index) => `img/jpg-sequence/zero/zero-${index.toString().padStart(3, "0")}.jpg`;

img.src = currentFrame(0);

canvas.width = 1920;
canvas.height = 1080;

img.onload = function () {
  context.drawImage(img, 0, 0);
};

const updateImage = (index) => {
  img.src = currentFrame(index);
  // context.drawImage(img, 0, 0);
};

let frameCount = 159;
let startAt = 0;
//   offset_value = 100;

var imagesLoaded = 0;
var images = [];

export const preloadZeroImages = () => {
  for (let i = startAt; i <= frameCount; i++) {
    let img = new Image();
    img.src = currentFrame(i);
    images.push(img);

    img.onload = function () {
      imagesLoaded += 1;
      // console.log("preloadng in zero called wussup");
    };
  }
};

// preloadZeroImages();

// change frames

gsap.to(".zero-section", {
  scrollTrigger: {
    trigger: ".sticky",
    // trigger: ".zero-section",
    start: "top top",
    // pinSpacing: false,
    end: () => `+=${document.querySelector(".zero-section").offsetHeight - window.innerHeight}`, // section height - window.innerheight
    // endTrigger: ".zero-section__end-trigger",
    pin: true,
    scrub: true,
    onUpdate: (self) => {
      // console.log("sticky inner: ", self.progress);
      const frameIndex = Math.min(frameCount - 1, startAt + Math.ceil(self.progress * (frameCount - startAt)));
      requestAnimationFrame(() => updateImage(frameIndex + 1));
    },
  },
});

// gsap.to(".zero-section", {
//   scrollTrigger: {
//     trigger: ".sticky",
//     start: "top top",
//     // pinSpacing: false,
//     end: () => `+=${document.querySelector(".zero-section").offsetHeight}`, // section height - window.innerheight
//     // endTrigger: ".zero-section__end-trigger",
//     pin: true,
//     scrub: true,
//     onUpdate: (self) => {
//       // console.log("sticky inner: ", self.progress);
//       // const frameIndex = Math.min(frameCount - 1, startAt + Math.ceil(self.progress * (frameCount - startAt)));
//       // requestAnimationFrame(() => updateImage(frameIndex + 1));
//     },
//   },
// });

// stick for a little longer

// we make peoples life

const peoplesLifeTl = gsap.timeline({ paused: true });

peoplesLifeTl.fromTo(".intro-images h2", { y: 50, opacity: 0 }, { opacity: 1, y: 0 });

peoplesLifeTl.fromTo(
  ".intro-images .tag",
  { y: 50, opacity: 0 },
  {
    opacity: 1,
    y: 0,
    stagger: (i) => {
      return i * 0.1;
    },
  },
  ">"
);

ScrollTrigger.create({
  trigger: ".intro-images",
  start: () => `top 80%`,
  end: "+=300",
  onUpdate: (self) => {
    peoplesLifeTl.progress(self.progress);
  },
});

// zero fee

// const zeroFeeTl = gsap.timeline({ paused: true });

// zeroFeeTl.fromTo(".zero-section__bottom h2", { y: 50, opacity: 0 }, { y: 0, opacity: 1 }, 0);

// zeroFeeTl.fromTo(".zero-section__bottom .title", { y: 50, opacity: 0 }, { y: 0, opacity: 1 }, 0.1);

// ScrollTrigger.create({
//   trigger: ".zero-section__bottom__content",
//   // start: `top ${window.innerHeight * 0.8}`,
//   start: () => `top 80%`,
//   // start: `top bottom-=6.25rem`,
//   // star
//   end: "+=300",
//   // end: () => window.innerHeight / 2,
//   onUpdate: (self) => {
//     console.log("zdrw!", self.progress);
//     zeroFeeTl.progress(self.progress);
//   },
// });
